import { render, staticRenderFns } from "./ExportDetailsDialog.vue?vue&type=template&id=08edd1b8&scoped=true&"
import script from "./ExportDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ExportDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edd1b8",
  null
  
)

export default component.exports